var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('router-link',{staticClass:"btnShop",attrs:{"to":"/shop"}},[_vm._v("SHOP")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }